import { Controller } from "@hotwired/stimulus"

// Read more under an offering's description (TMS-1613 design): on a phone the stylesheet clamps
// the text to a few lines, and the toggle shows only while that clamp actually hides some of it.
export default class extends Controller {
  static targets = ["content", "toggle"]

  connect() {
    this.measure = this.measure.bind(this)
    this.resizeObserver = new ResizeObserver(this.measure)
    this.resizeObserver.observe(this.contentTarget)
    this.measure()
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  toggle() {
    const expanded = !this.element.classList.contains("is-expanded")
    this.element.classList.toggle("is-expanded", expanded)
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    this.toggleTarget.textContent = expanded ? "Read less" : "Read more"
  }

  // Expanded text has nothing hidden, so it keeps its toggle to collapse again.
  measure() {
    if (this.element.classList.contains("is-expanded")) return

    const content = this.contentTarget
    this.toggleTarget.hidden = content.scrollHeight <= content.clientHeight + 1
  }
}
